import React, { useState, useEffect, useRef, Dispatch, ChangeEvent, useCallback } from "react";
import Draggable from "react-draggable";
import "../../../App.css";
import { ResizableBox, ResizeCallbackData } from "react-resizable";
import { ItemTypes, PopupsListType, SimulationType } from '../../../initial/menu/RightSideMenu';
import "react-resizable/css/styles.css";
import DataTable, { GenerateEarlyWarningTypes } from '../../../mainLayer/simulationPopup/DataTable';
import loadIco from '../../../assets/loading-ico.gif'
import closeIco from '../../../assets/close-icon-color.png'
import { NotificationType } from '../../../mainLayer/simulationPopup/NotificationPopup';
import ViewMap from "../../../simulation/SimulationPopUp/SimulationPopUpMap/ViewSimulationMap";
import ViewForecastMap from "../../../simulation/Forecast/ForecastMap/ViewForecastMap";

interface Props {
  sensorId: string;
  name: string;
  pm10: number;
  pm25: number;
  pm100: number;
  co2: number;
  temperature: number;
  aqi: number;
  timestamp: string;
  /* New start */
  windowState: Dispatch<React.SetStateAction<boolean>>
  /* New end */
}

/* New start */
type TornadoSimulationCompPopupProps = {
	//windowState: Dispatch<React.SetStateAction<ExtremeWetherSelectionTypes>>;
    terminalState: Dispatch<React.SetStateAction<boolean>>;
    terminalCommands: Dispatch<React.SetStateAction<string[]>>;
    notifications: Dispatch<React.SetStateAction<NotificationType[]>>;
    handleClosePopup:() =>void;
    addItem?: (id: string, type: ItemTypes) => void;
    id?: string;
    runButtonOnClick: (simulationName: string) => void;
 
}
/* New end */

const TornadoSimulationComp = (props: TornadoSimulationCompPopupProps) => {
  const [showDialog, setShowDialog] = useState<boolean>(true);
  const [lastUpdate, setLastUpdate] = useState<string | null>(null);
  const [showSensorDetails, setShowSensorDetails] = useState(false);
  const [activeFullScreen, setActiveFullScreen] = useState<boolean>(false);
  const fullscreenModal = useRef<HTMLDivElement | null>(null);
  const parentContainerRef = useRef<HTMLDivElement | null>(null);
  const [showDescription, setShowDescription] = useState(false);
  const [widthMain, setWidthMain] = useState<number>(0);
  const [heightMain, setHeightMain] = useState<number>(0);

  const [dimensions, setDimensions] = useState({
    resizableBoxwidth: 0,
    resizableBoxheight: 0,
  });

  const [dimensionsMin, setDimensionsMin] = useState({
    resizableBoxMinwidth: 0,
    resizableBoxMinheight: 0,
  });

  //----------------resibleBox Function----------------

  const updateDimensions = () => {
    const vw = Math.max(
      document.documentElement.clientWidth || 0,
      window.innerWidth || 0
    );
    const vh = Math.max(
      document.documentElement.clientHeight || 0,
      window.innerHeight || 0
    );

    // setDimensions({
    //   resizableBoxwidth: vw * 0.68,
    //   resizableBoxheight: vh * 0.75,
    // });

    // setDimensionsMin({
    //   resizableBoxMinwidth: vw * 0.4,
    //   resizableBoxMinheight: vh * 0.72,
    // });

    if (vw > 2000 && vh > 1200) {
      setDimensions({
        resizableBoxwidth: vw * 0.4,
        resizableBoxheight: vh * 0.5,
      });
    } else {
      setDimensions({
        resizableBoxwidth: vw * 0.5,
        resizableBoxheight: vh * 0.8,
      });
    }

    if (vw > 2000 && vh > 1200) {
      setDimensionsMin({
        resizableBoxMinwidth: vw * 0.2,
        resizableBoxMinheight: vh * 0.3,
      });
    } else {
      setDimensionsMin({
        resizableBoxMinwidth: vw * 0.3,
        resizableBoxMinheight: vh * 0.4,
      });
    }
  };

  useEffect(() => {
    updateDimensions();
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  const openContentFullscreen = () => {
    if (!document.fullscreenElement) {
      enterFullscreen();
      setShowSensorDetails(true);
    } else {
      exitFullScreen();
      setShowSensorDetails(false);
    }
  };

  const enterFullscreen = () => {
    const elem = fullscreenModal.current;
    if (elem) {
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      }
      setActiveFullScreen(true);
    }
  };

  const exitFullScreen = () => {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if ((document as any).mozCancelFullScreen) {
      (document as any).mozCancelFullScreen();
    } else if ((document as any).webkitExitFullscreen) {
      (document as any).webkitExitFullscreen();
    } else if ((document as any).msExitFullscreen) {
      (document as any).msExitFullscreen();
    }
    setActiveFullScreen(false);
  };

  /* useEffect(() => {
    const fetchCurrentSensorsData = async () => {
      try {
        const response = await fetch(
          "https://mobile.mobilise-project.org.uk/mobisense/air/sensors/threeDaysData?id=" +
            props.sensorId
        );
        const responseData = await response.json();

        if (responseData && typeof responseData === "object") {
          const { maxTimestamp } = responseData;
          setLastUpdate(maxTimestamp);
        } else {
          console.error("Invalid response data format:", responseData);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchCurrentSensorsData();
    return () => {};
  }, [props.sensorId]); */

  const headerStyle: React.CSSProperties = {
    cursor: "move",
    marginBottom: "10px",
    display: "absolute",
  };

  const date = new Date().toLocaleDateString();
  const time = new Date().toLocaleTimeString();

  const hideDialog = () => {
    setShowDialog(false);
 
  };
  const setAqiCondition = (aqiValue: number): string => {
    if (aqiValue !== null) {
      if (0 < aqiValue && aqiValue <= 50) {
        return "Good";
      } else if (50 < aqiValue && aqiValue <= 100) {
        return "Moderate";
      } else if (100 < aqiValue && aqiValue <= 150) {
        return "Unhealthy for sensitive group";
      } else if (150 < aqiValue && aqiValue <= 200) {
        return "Unhealthy";
      } else if (200 < aqiValue && aqiValue <= 300) {
        return "Very unhealthy";
      } else if (300 < aqiValue && aqiValue <= 500) {
        return "Hazardous";
      }
    }
    return "Good";
  };

  useEffect(() => {}, [showDescription]);



  useEffect(() => {
  }, [widthMain,heightMain]);

  const handleResize = (
    event: React.SyntheticEvent,
    data: ResizeCallbackData
  ) => {
    setWidthMain(data.size.width);
   setHeightMain(data.size.height)

    if (data.size.width < 900) {
      // Set your desired width threshold
      setShowDescription(true);
    } else {
      setShowDescription(false);
    }
  };

  /* New start */
  // Selected tab
	const [selectedTab, setSelectedTab] = useState<'simulation_tab' | 'forecast_tab' | 'analyse_impact_tab' | 'generate_early_warning_tab'>('simulation_tab')

  // custom value status
  const [isCustomValueOpen, setIsCustomValueOpen] = useState<boolean>(false)
  // Loading screen
  const [isLoading, setIsLoading] = useState<boolean>(false)
	// Data
	// Flood model type data
	const [floodModelTypes, setFloodModelTypes] = useState<{name: string; value: string}[]>([
		{name: 'Flood Type 1', value: 'floodType_1'},
		{name: 'Flood Type 2', value: 'floodType_2'},
		{name: 'Flood Type 3', value: 'floodType_3'},
		{name: 'Flood Type 4', value: 'floodType_4'}
	])
	// Forecast type data
	const [forecastTypes, setForecastTypes] = useState<{name: string; value: string}[]>([
		{name: 'Forecast 1', value: 'forecast_1'},
		{name: 'Forecast 2', value: 'forecast_2'},
		{name: 'Forecast 3', value: 'forecast_3'},
		{name: 'Forecast 4', value: 'forecast_4'}
	])
	// River sensors data
	const [riverSensorTypes, setRiverSensorTypes] = useState<{name: string; value: string}[]>([
		{name: 'River Sensor 1', value: 'river_sensor_1'},
		{name: 'River Sensor 2', value: 'river_sensor_2'},
		{name: 'River Sensor 3', value: 'river_sensor_3'},
		{name: 'River Sensor 4', value: 'river_sensor_4'}
	])
	// River sensors data
	const [buildingDataFrom, setBuildingDataFrom] = useState<{name: string; value: string}[]>([
		{name: 'Building Data From 1', value: 'building_data_from_1'},
		{name: 'Building Data From 2', value: 'building_data_from_2'},
		{name: 'Building Data From 3', value: 'building_data_from_3'},
		{name: 'Building Data From 4', value: 'building_data_from_4'}
	])

	// Input values
	const simulationNameRef = useRef<HTMLInputElement | null>(null)
	const simulationFloodModelRef = useRef<HTMLSelectElement | null>(null)
	const simulationForecastRef = useRef<HTMLSelectElement | null>(null)
	const simulationRiverSensorsRef = useRef<HTMLSelectElement | null>(null)
	const forecastShowCatchmentAreaRef = useRef<HTMLInputElement | null>(null)
	const forecastPublishRef = useRef<HTMLInputElement | null>(null)
	
	// Handle simulation tab next button click
	const handleSimulationTabNextButtonClick = () => {
    /* if(simulationNameRef.current?.value && simulationFloodModelRef.current?.value !== 'null' && simulationForecastRef.current?.value !== 'null')
    {
      console.log('run')
    } */
    setIsLoading(true)
    props.terminalState(true)
    props.terminalCommands(prevState => [...prevState, 'terminal starting....'])
    let count = 0
    const terminalData = setInterval(() => {
      props.terminalCommands(prevState => [...prevState, 'command ' + count])
      count += 1

      if(count > 10) 
      {
        clearTimeout(terminalData)
        props.terminalCommands(prevState => [...prevState, 'terminal ended....'])
        setIsLoading(false)
        props.notifications(prevState => [...prevState, {type: 'success', message: 'test successfully completed'}])
      }
    }, 500)
    
	}

	// Handle forecast tab next button click
	const handleForecastTabNextButtonClick = () => {
		console.log('forecast tab next button clicked')
    setSelectedTab('analyse_impact_tab')
	}

	// Handle analyse impact tab next button click
	const handleAnalyseImpactTabNextButtonClick = () => {
		console.log('analyse impact tab next button clicked')
    setSelectedTab('generate_early_warning_tab')
	}

	// Handle generate ew tab next button click
	const handleGenerateEWTabNextButtonClick = () => {
		console.log('generate ew tab trigger button clicked')
	}

  const rows: GenerateEarlyWarningTypes[] = [
    { id: 51040, buildingId: 51040, buildingType: 'BLDGA', buildingOwnerName: 'Nihal Perera', mobileNumber: '0711111111', areaOfRisk: '91780.2011292', maximumDepth: 200, startTime: '05/01/2024, 18:00', peakTime: '05/01/2024, 18:00'},
    { id: 51041, buildingId: 51041, buildingType: 'BLDGA', buildingOwnerName: 'Gihan Fernando', mobileNumber: '0711111111', areaOfRisk: '91780.2011292', maximumDepth: 200, startTime: '05/01/2024, 18:00', peakTime: '05/01/2024, 18:00'}
  ];
  /* New end */


  const popupRef = useRef<HTMLDivElement | null>(null)
  const enteredRef = useRef<boolean>(false)

  const mouseMoveEvent = useCallback((event: MouseEvent) => {
    const sideMenu = document.getElementById('side-menu-wrapper');
    
    if (sideMenu && !enteredRef.current) {
        const sideMenuWidth = Number(window.getComputedStyle(sideMenu).left.slice(0, -2));

        if (sideMenuWidth < event.clientX) {
          enteredRef.current = true
          if(props.id && props.addItem){
            props.addItem(props.id, 'tornado')
            /* props.windowState(false) */
            setShowDialog(false)
          }
        }
    }
}, [])

  useEffect(() => {
    const handleMouseDown = () => {
        document.addEventListener('mousemove', mouseMoveEvent);
        document.addEventListener('mouseup', handleMouseUp);
    };

    const handleMouseUp = () => {
        document.removeEventListener('mousemove', mouseMoveEvent);
    };

    if (popupRef.current) {
        popupRef.current.addEventListener('mouseenter', () => {
            popupRef.current?.addEventListener('mousedown', handleMouseDown);
        });
    }

    return () => {
        document.removeEventListener('mousemove', mouseMoveEvent);
        document.removeEventListener('mouseup', handleMouseUp);
    };
  }, [mouseMoveEvent])
  return (
    <div className="ol-overlay-container ol-selectable">
      <div style={{ visibility: showDialog ? "visible" : "hidden", position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)'}} ref={parentContainerRef}>
        <Draggable handle=".titleContainer" cancel=".no-drag" enableUserSelectHack={false}>
          <ResizableBox className="custom-resizable-box" width={dimensions.resizableBoxwidth} height={dimensions.resizableBoxheight} minConstraints={[ dimensionsMin.resizableBoxMinwidth, dimensionsMin.resizableBoxMinheight, ]} onResize={handleResize} resizeHandles={["se", "sw", "ne", "nw"]} >
            

          <div className="drag-handle" ref={fullscreenModal} style={{
                bottom: 0,
                margin: "auto",
             
                width: "100%", //"65vw",
                height: "100%", //"60vh,"
                position: "absolute",
      
                cursor: "move",
                touchAction: "none",
              }}
            >


                <div className={`simulationPopupContainer`}>
                  {/* Title container */}
                  <div className={`titleContainer`} ref={popupRef}>
                      <span>Tornado and Severe Thunderstorm Environments simulation</span>
                      <div className={`titleButtonContainer`}>
                      <i className={`titleIcon fullScreenIco`}></i>
                      <i className={`titleIcon closeIco`}   onClick={hideDialog}
                      onTouchStart={hideDialog}></i>
                      </div>
                  </div>
                  {/* Tab area */}
                  <div className={`tabArea`}>
                      <div className={`tabButton ${selectedTab === 'simulation_tab' ? 'tabSelected' : ''}`} id='simulation_tab' onClick={(e) => setSelectedTab(prevState => 'simulation_tab')}>simulation</div>
                      <div className={`tabButton ${selectedTab === 'forecast_tab' ? 'tabSelected' : ''}`} id='forecast_tab' onClick={(e) => setSelectedTab(prevState => 'forecast_tab')}>forecast</div>
                      <div className={`tabButton ${selectedTab === 'analyse_impact_tab' ? 'tabSelected' : ''}`} id='analyse_impact_tab' onClick={(e) => setSelectedTab(prevState => 'analyse_impact_tab')}>analyse impact</div>
                      <div className={`tabButton ${selectedTab === 'generate_early_warning_tab' ? 'tabSelected' : ''}`} id='generate_early_warning_tab' onClick={(e) => setSelectedTab(prevState => 'generate_early_warning_tab')}>generate early warning</div>
                  </div>

                  {/* Simulation data container */}
                  {selectedTab === 'simulation_tab' && (
                    <div className={`simulationTabDataWrapper tabDataContainer`}>
                      {/* Left data container */}
                      <div className={`leftDataContainer`}>

                        <div className={`inputItemContainer`}>
                          <label htmlFor="simulation_popup_simulation_name_input">simulation name</label>
                          <input id='simulation_popup_simulation_name_input' type="text" placeholder='Enter Simulation name' ref={simulationNameRef} />
                        </div>

                        <div className={`inputItemContainer`}>
                          <label htmlFor="simulation_popup_flood_model_select">Model type</label>
                          <select name="flood_model_type" id='simulation_popup_flood_model_select' ref={simulationFloodModelRef}>
                            <option value={''} disabled selected>Select...</option>
                            {floodModelTypes.map((option, index) => (
                              <option key={index} value={option.value}>{option.name}</option>
                            ))}
                          </select>
                        </div>

                        <div className={`inputItemContainer`}>
                          <label htmlFor="simulation_popup_forecast_select">forecast</label>
                          <select name="forecast_type" id='simulation_popup_forecast_select' ref={simulationForecastRef}>
                            <option value={''} disabled selected>Select...</option>
                            {forecastTypes.map((option, index) => (
                              <option key={index} value={option.value}>{option.name}</option>
                            ))}
                          </select>
                        </div>

                        <div className={`customValueWrapper`}>
                          <div className={`titleWrapper`} onClick={(e) => setIsCustomValueOpen(prevStatus => !prevStatus)}>
                            <span className={`title`}>custom value</span>
                            <div className={`icon ${isCustomValueOpen ? 'bgUp' : 'bgDown'}`}></div>
                          </div>
                          <div className={`dataContainer`} style={{display: isCustomValueOpen ? 'block' : 'none'}}>
                            <div className={`inputItemContainer`}>
                              <label htmlFor="simulation_popup_river_sensors_select">river sensors</label>
                              <select name="river_sensor_type" id='simulation_popup_river_sensors_select' ref={simulationRiverSensorsRef}>
                                <option value={''} disabled selected>Select...</option>
                                {riverSensorTypes.map((option, index) => (
                                  <option key={index} value={option.value}>{option.name}</option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>

                      </div>
                      {/* Right map container */}
                      <div className={`rightMapContainer`}>
                          {/* Map here */}
                          <ViewMap />
                      </div>
                      <div className={`bottomContainer`}>
                        <button onClick={(e) => handleSimulationTabNextButtonClick()}>run</button>
                      </div>
                    </div>
                  )}

                  {/* Forecast data container */}
                  {selectedTab === 'forecast_tab' && (
                    <div className={`forecastTabDataWrapper tabDataContainer`}>
                      <div className={`forecastMap`}>
                        {/* Forecast map here */}
                        <ViewForecastMap />
                      </div>
                      <div className={`bottomMenu`}>
                        <input type="checkbox" name="" id="simulation_popup_forecast_show_catchment_area" ref={forecastShowCatchmentAreaRef} />
                        <label htmlFor="simulation_popup_forecast_show_catchment_area">show catchment area</label>

                        <input type="checkbox" name="" id="simulation_popup_publish" ref={forecastPublishRef} />
                        <label htmlFor="simulation_popup_publish">publish</label>

                        <button onClick={(e) => handleForecastTabNextButtonClick()}>next</button>
                      </div>
                    </div>
                  )}

                  {/* Analyse impact data container */}
                  {selectedTab === 'analyse_impact_tab' && (
                    <div className={`analyseImpactTabDataWrapper tabDataContainer`}>
                      <span className={`titleContainer`}>Select to generate early warning</span>
                      <div className={`buildingDataFromSelector`}>
                        <label htmlFor="">Building Data From</label>
                        <select name="" id="">
                          <option value={''} disabled selected>Select...</option>
                            {buildingDataFrom.map((option, index) => (
                              <option key={index} value={option.value}>{option.name}</option>
                            ))}
                        </select>
                      </div>
                      <div className={`checkBoxContainer`}>
                        <div className={`item`}>
                          <input type="checkbox" name="" id="simulation_popup_buildingID" ref={forecastPublishRef} />
                          <label htmlFor="simulation_popup_buildingID">Building ID</label>
                        </div>
                        <div className={`item`}>
                          <input type="checkbox" name="" id="simulation_popup_building_owner_name" ref={forecastPublishRef} />
                          <label htmlFor="simulation_popup_building_owner_name">Building Owner Name</label>
                        </div>
                        <div className={`item`}>
                          <input type="checkbox" name="" id="simulation_popup_mobile_number" ref={forecastPublishRef} />
                          <label htmlFor="simulation_popup_mobile_number">Mobile Number</label>
                        </div>
                        <div className={`item`}>
                          <input type="checkbox" name="" id="simulation_popup_building_type" ref={forecastPublishRef} />
                          <label htmlFor="simulation_popup_building_type">Building Type</label>
                        </div>
                        <div className={`item`}>
                          <input type="checkbox" name="" id="simulation_popup_maximum_depth" ref={forecastPublishRef} />
                          <label htmlFor="simulation_popup_maximum_depth">Maximum Depth</label>
                        </div>
                        <div className={`item`}>
                          <input type="checkbox" name="" id="simulation_popup_start_time" ref={forecastPublishRef} />
                          <label htmlFor="simulation_popup_start_time">Start Time</label>
                        </div>
                        <div className={`item`}>
                          <input type="checkbox" name="" id="simulation_popup_peak_type" ref={forecastPublishRef} />
                          <label htmlFor="simulation_popup_peak_type">Peak Type</label>
                        </div>
                      </div>
                      <div className={`bottomContainer`}>
                        <button onClick={(e) => handleAnalyseImpactTabNextButtonClick()}>next</button>
                      </div>
                    </div>
                  )}

                  {/* Generate early warning data container */}
                  {selectedTab === 'generate_early_warning_tab' && (
                    <div className={`generateEarlyWarningTabDataWrapper tabDataContainer`}>
                      <div className={`tableContainer`}>
                        {/* Table here */}
                        <DataTable data={rows} />
                      </div>

                      <div className={`bottomContainer`}>
                        <button onClick={(e) => handleGenerateEWTabNextButtonClick()}>trigger</button>
                      </div>
                    </div>
                  )}

                  {/* Loading screen */}
                  {isLoading && (
                    <div className={`loadingScreen`}>
                      <img className={`loadImg`} src={loadIco} alt="" />
                      <img className={`closeImg`}  src={closeIco} alt="" onClick={(e) => {
                        setIsLoading(false)
                        props.terminalState(false)
                        props.terminalCommands([])
                      }} />
                    </div>
                  )}
              </div>
            </div>
          </ResizableBox>
        </Draggable>
      </div>
    </div>
  )
}
export default TornadoSimulationComp;
